import React from 'react';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-b from-slate-50 to-white pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gradient-to-r from-ocean-900 via-ocean-800 to-ocean-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Terms of Service</h1>
            <p className="text-white/80">Last updated: December 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 space-y-8">
            
            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">1. Acceptance of Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                By booking an adventure with Dive Camp Adventures, you agree to these terms and conditions. Please read them carefully before making a booking.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">2. Booking & Payment</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
                <li>Full payment is required at the time of booking</li>
                <li>Payments are processed securely through Stripe</li>
                <li>Prices are in Australian Dollars (AUD)</li>
                <li>Booking confirmation will be sent via email</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">3. Cancellation Policy</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
                <li><strong>7+ days before:</strong> Full refund minus processing fees</li>
                <li><strong>3-7 days before:</strong> 50% refund or free reschedule</li>
                <li><strong>Less than 3 days:</strong> No refund, reschedule subject to availability</li>
                <li><strong>Weather cancellations:</strong> Full refund or free reschedule</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">4. Health & Safety Requirements</h2>
              <p className="text-slate-600 leading-relaxed mb-3">
                For diving activities, participants must:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
                <li>Be in good physical health</li>
                <li>Complete a medical questionnaire honestly</li>
                <li>Obtain medical clearance if required</li>
                <li>Not be under the influence of alcohol or drugs</li>
                <li>Follow all safety instructions from the guide</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">5. Assumption of Risk</h2>
              <p className="text-slate-600 leading-relaxed">
                Diving and outdoor activities involve inherent risks. By participating, you acknowledge and accept these risks. You agree to follow all safety guidelines and instructions provided by your guide.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">6. Equipment</h2>
              <p className="text-slate-600 leading-relaxed">
                All necessary diving and camping equipment is provided unless otherwise stated. Participants are responsible for any damage to equipment caused by negligence or misuse.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">7. Weather Conditions</h2>
              <p className="text-slate-600 leading-relaxed">
                Activities are weather-dependent. We reserve the right to modify or cancel activities due to unsafe conditions. In case of weather cancellation, you will receive a full refund or the option to reschedule.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">8. Photos & Media</h2>
              <p className="text-slate-600 leading-relaxed">
                Photos and videos may be taken during adventures for promotional purposes. Please inform us if you do not wish to be photographed.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">9. Contact</h2>
              <p className="text-slate-600 leading-relaxed">
                For questions about these terms or your booking, please contact us:
              </p>
              <p className="text-coral-600 font-medium mt-2">divecampadventures@gmail.com</p>
              <p className="text-coral-600 font-medium">WhatsApp: +61 414 710 541</p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
